import { gql } from '@apollo/client';

export const GET_DISTRIBUTION_PARTNERS = gql`
  query GET_DISTRIBUTION_PARTNERS {
    getDistributionPartners {
      id
      name
    }
  }
`;
